import type { SVGProps } from 'react';

const SvgMessageOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={props.color}
      d="M17 10a1 1 0 0 1-1 1H8a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1Zm-4 5a1 1 0 1 0 0-2H8a1 1 0 1 0 0 2h5Z"
    />
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 1.536-.405 2.97-1 4.23V21h-4.77c-1.26.595-2.694 1-4.23 1-5.523 0-10-4.477-10-10Zm10-8a8 8 0 1 0 0 16c1.25 0 2.456-.35 3.555-.895l.21-.105H19v-3.235l.105-.21C19.65 14.455 20 13.25 20 12a8 8 0 0 0-8-8Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgMessageOutline;
